import { Module } from '@/modules/core/app/constants/app.constants';
import { GoalPathName, GoalRoute } from '@/modules/ta/goal/goal.constants';
import { GoalRouteConfig } from '@/modules/ta/goal/GoalRouteConfig';

export const router = GoalRouteConfig.factory(
  [
    {
      path: `/${GoalRoute.TESTGOALS}`,
      name: GoalPathName.TESTGOALS,
      component: () => import(/* webpackChunkName: "goals-page" */ './pages/GoalsPage.vue'),
    },
    {
      path: `/${GoalRoute.TESTGOALS}/new`,
      name: GoalPathName.TESTGOALFORM_NEW,
      component: () => import(/* webpackChunkName: "goal-form-page" */ './pages/GoalFormPage.vue'),
      props: true,
    },
    {
      path: `/${GoalRoute.TESTGOALS}/duplicate/:id`,
      name: GoalPathName.TESTGOALFORM_DUPLICATE,
      component: () => import(/* webpackChunkName: "goal-form-page" */ './pages/GoalFormPage.vue'),
      props: {
        isDuplicating: true,
      },
    },
    {
      path: `/${GoalRoute.TESTGOALS}/:id/:cycleId?`,
      name: GoalPathName.TESTGOALFORM,
      component: () => import(/* webpackChunkName: "goal-form-page" */ './pages/GoalFormPage.vue'),
      props: true,
    },
  ],
  Module.GOAL
);
